import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1507255f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "server-navigation",
  class: "full-height-section gap-2"
}

import { onMounted } from 'vue';
import GuildCreate from './guild/GuildCreate.vue';
import { useUserStore } from '../stores/UserStore';
import { useGuildNavigationStore } from '@/stores/GuildNavigationStore';
import { useDialogStore } from '@/stores/DialogStore';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBaseNavigation',
  setup(__props) {

const userStore = useUserStore();
const guildNavigationStore = useGuildNavigationStore();
const dialogStore = useDialogStore();

onMounted(() => {
  guildNavigationStore.fetchGuilds();
});

function onCreateGuild(){
  dialogStore.openDialog(GuildCreate, 'Create your new guild');
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(guildNavigationStore).guilds, (guild) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: "guild-link",
        key: guild.id,
        to: { name: 'guild', params: { guildId: guild.id } }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(guild.name), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128)),
    _createVNode(_component_router_link, {
      to: "/base/guild-explore",
      style: {"margin-top":"1rem"}
    }, {
      default: _withCtx(() => [
        _createTextVNode("Explore guilds")
      ]),
      _: 1
    }),
    _createVNode(_unref(Button), {
      label: "Create guild",
      class: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onCreateGuild()))
    }),
    _createVNode(_unref(Button), {
      label: "Log Out",
      class: "mt-auto",
      onClick: _unref(userStore).logOutUser
    }, null, 8, ["onClick"])
  ]))
}
}

})